<template>
  <div class="row">
    <div class="col-12 col-lg-6 c g">
        <div class="card card-body">
            <a href="https://play.google.com/store/apps/details?id=com.brmja.octowhats&hl=ar" target="_blank" class="btn btn-block btn-lg btn-success">
                تحميل للاندرويد
            </a>
            <br>
            <a href="https://apps.apple.com/eg/app/%D8%A7%D9%88%D9%83%D8%AA%D9%88-%D9%88%D8%A7%D8%AA%D8%B3/id6741829235?l=ar" target="_blank" class="btn btn-block btn-lg btn-primary">
                تحميل للايفون
            </a>
        </div>
    </div>
  </div>
</template>

<script>
export default {

}
</script>

<style>

</style>